import { TableView } from 'owa-mail-list-store';

/**
 * Filter the row keys by existence in the table
 * @param rowKeys to be filtered
 * @param tableView that used to be a reference
 * @returns filtered row keys if the key presents in the tableView.rowKeys
 */
export default function filterRowKeysByExistence(
    rowKeys: string[],
    tableView: TableView
): string[] {
    return rowKeys.filter(rowKey => tableView.rowKeys.indexOf(rowKey) >= 0);
}
